import { render, staticRenderFns } from "./PlatformCard.vue?vue&type=template&id=6795d526"
import script from "./PlatformCard.vue?vue&type=script&lang=js"
export * from "./PlatformCard.vue?vue&type=script&lang=js"
import style0 from "./PlatformCard.vue?vue&type=style&index=0&id=6795d526&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports